import React from 'react';
import { BankDetailsContainer } from '../../../containers';

export const BankDetails = () => <BankDetailsContainer />;
